<template>
  <div id="content" class="pageDataPolicy">
    <div class="container">
      <div class="pageDataPolicyContent">
    <QuillEditor ref="datapolicyContentEditor"  theme="snow" v-model="content" :content="content" contentType="html" :toolbar="toolbarOptions" />
    <div class="">
      <button type="button" name="button" class="next_step_btn" @click="savedp">Save</button>
    </div>
  </div>
  </div>
  </div>
</template>
<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
 import {toast } from 'vue-sonner'
 import api from '@/tools/api';
// Add fonts to whitelist


export default {
  components: {
    QuillEditor,

    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      pageInfo: {
        mainTitle : "Terms and conditions",
        subTitle : "Update terms and conditions",
      },
      toolbarOptions : [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
        [{ 'header': [1, 2, 3, false] }],
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        ['clean']                                         // remove formatting button
      ],
      contentHTML:"",
      content:"",

    }
  },
  methods:{

    savedp(){
          var post ={ termsandconditions : this.$refs.datapolicyContentEditor.getHTML()};

          api.post(process.env.VUE_APP_API_URL+"/restrict/termsandconditions",post,{
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then( (r) => {
            console.log(r);
            toast.success("Terms and conditions saved");

          }).catch( () => {
            toast.error("Error during generation. Please try again.");
          });

    },


  },
  computed:{

  },

  mounted(){
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
    api.get(process.env.VUE_APP_API_URL+"/termsandconditions").then( (r) => {
      console.log(r);
      this.$refs.datapolicyContentEditor.setHTML(r.data.termsandconditions);
    }).catch( (e) => {
      console.log(e);


       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     });
  }
}
</script>
<style scoped >
.pageDataPolicy{
  padding-top:50px;
  padding-bottom: 50px;
}
.pageDataPolicyContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-bottom: 50px;

}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
</style>

<style media="screen">
  .ql-editor{
    min-height:400px;
  }

</style>
